import React, { memo, useMemo } from 'react';
import { useSelector } from "react-redux";
import { State } from "../../reducers";
import './ExerciseSetRep.css';
import { useTranslation } from 'react-i18next';

// Memoized selector to prevent unnecessary re-renders
const selectCurrentRep = (state: State) => state.activities.currentRep;

const ExerciseSetRep = memo(() => {
    const { t } = useTranslation('common');
    const currentRep = useSelector(selectCurrentRep);
    
    // Use useMemo to prevent unnecessary recalculations
    const repDisplay = useMemo(() => {
        if (currentRep?.repIndex) {
            return `${currentRep.repIndex} / ${currentRep.repCount || 0}`;
        }
        return null;
    }, [currentRep?.repIndex, currentRep?.repCount]);
    
    const setDisplay = useMemo(() => {
        if (currentRep?.setIndex) {
            return `${currentRep.setIndex} / ${currentRep.setCount || 0}`;
        }
        return '0 / 0';
    }, [currentRep?.setIndex, currentRep?.setCount]);

    return (
        <div className='setRepContainer'>
            <div className='repTxt'>
                {t('training.rep')} : {repDisplay}
            </div>
            <div className='setTxt'>
                {t('training.set')} : {setDisplay}
            </div>
        </div>
    )
});

export { ExerciseSetRep };